import React, { useEffect, useContext } from "react";
import { CallAPI } from "services/API";
import { DeviceContext } from 'utils/Device/DeviceContext';
import TableWithContainer from "utils/Table/TableWithContainer";
import TooltipButton from "utils/TooltipButton/TooltipButton";
import { Grid } from "@material-ui/core";

export default function PoliciesDMA(props) {
    const device = useContext(DeviceContext);
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    const style = {
        Title: { lineHeight: "1em", fontSize: device.isMobile ? "1.3em" : "2.5em" },
        Table: {
            TableSX: { tableLayout: "auto" },
            FixedColumn: { width: "120px" },
            Header: { minWidth: "120px", lineHeight: "1em", whiteSpace: 'nowrap' },
        }
    };
    const headers = [[props.groupBy]];

    switch (props.state) {
        case 'MI':
            headers[0].push(
                "Detroit", "Flint", "Grand Rapids", "Lansing", "Traverse City", "Marquette UP",
                {
                    text: (<>Other<TooltipButton tooltipText={`"Other" includes the following 5 DMAs: Toledo, South Bend-Elkhart, Alpena, Dultuh-Superior, GreenBay-Appleton`} /></>),
                    style: { padding: "0" }
                },
            );
            break;
        case 'NJ':
            headers[0].push(
                "New York-North Jersey",
                "Philadelphia-South Jersey",
            );
            break;
        case 'PA':
            headers[0].push(
                "Philadelphia", "Pittsburgh", "Harrisburg-Lancaster-Lebanon-York",
                "Wilkes Barre-Scranton-Hazleton", "Johnstown-Altoona-State College", "Erie",
                {
                    text: (<>Other<TooltipButton tooltipText={`"Other" includes the following 5 DMAs: New York, Washington-Hagerstown, Buffalo, Youngstown, Elmira-Corning`} /></>),
                    style: { padding: "0" }
                },
            );
            break;
    }

    const [data, setData] = React.useState([]);
    const [dataPremium, setDataPremium] = React.useState([]);
    const [dataAvgPremium, setDataAvgPremium] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const GetData = async () => {
        const response = await CallAPI("POST", `/DMA/GetPolicies${props.state}`, {
            startDate: props.startDate,
            endDate: props.endDate,
            groupBy: props.groupBy
        });

        if (response) {
            const policies = [];
            const totalPremium = [];
            const averagePremium = [];

            switch (props.state)
            {
                case 'MI':
                    response.forEach((row) => {
                        policies.push([
                            row.groupBy,
                            integer.format(row.detroit),
                            integer.format(row.flint),
                            integer.format(row.grandRapids),
                            integer.format(row.lansing),
                            integer.format(row.traverseCity),
                            integer.format(row.marquetteUP),
                            integer.format(row.other),
                        ]);
                        totalPremium.push([
                            row.groupBy,
                            currency.format(row.detroitPremium),
                            currency.format(row.flintPremium),
                            currency.format(row.grandRapidsPremium),
                            currency.format(row.lansingPremium),
                            currency.format(row.traverseCityPremium),
                            currency.format(row.marquetteUPPremium),
                            currency.format(row.otherPremium),
                        ]);
                        averagePremium.push([
                            row.groupBy,
                            currency.format(row.detroitAvgPremium),
                            currency.format(row.flintAvgPremium),
                            currency.format(row.grandRapidsAvgPremium),
                            currency.format(row.lansingAvgPremium),
                            currency.format(row.traverseCityAvgPremium),
                            currency.format(row.marquetteUPAvgPremium),
                            currency.format(row.otherAvgPremium),
                        ]);
                    });
                    break;
                case 'NJ':
                    response.forEach((row) => {
                        policies.push([
                            row.groupBy,
                            integer.format(row.newYorkNorthJersey),
                            integer.format(row.philadelphiaSouthJersey),
                        ]);
                        totalPremium.push([
                            row.groupBy,
                            currency.format(row.newYorkNorthJerseyPremium),
                            currency.format(row.philadelphiaSouthJerseyPremium),
                        ]);
                        averagePremium.push([
                            row.groupBy,
                            currency.format(row.newYorkNorthJerseyAvgPremium),
                            currency.format(row.philadelphiaSouthJerseyAvgPremium),
                        ]);
                    });
                    break;
                case 'PA':
                    response.forEach((row) => {
                        policies.push([
                            row.groupBy,
                            integer.format(row.philadelphia),
                            integer.format(row.pittsburgh),
                            integer.format(row.harrisburgLancasterLebanonYork),
                            integer.format(row.wilkesBarreScrantonHazleton),
                            integer.format(row.johnstownAltoonaStateCollege),
                            integer.format(row.erie),
                            integer.format(row.other),
                        ]);
                        totalPremium.push([
                            row.groupBy,
                            currency.format(row.philadelphiaPremium),
                            currency.format(row.pittsburghPremium),
                            currency.format(row.harrisburgLancasterLebanonYorkPremium),
                            currency.format(row.wilkesBarreScrantonHazletonPremium),
                            currency.format(row.johnstownAltoonaStateCollegePremium),
                            currency.format(row.eriePremium),
                            currency.format(row.otherPremium),
                        ]);
                        averagePremium.push([
                            row.groupBy,
                            currency.format(row.philadelphiaAvgPremium),
                            currency.format(row.pittsburghAvgPremium),
                            currency.format(row.harrisburgLancasterLebanonYorkAvgPremium),
                            currency.format(row.wilkesBarreScrantonHazletonAvgPremium),
                            currency.format(row.johnstownAltoonaStateCollegeAvgPremium),
                            currency.format(row.erieAvgPremium),
                            currency.format(row.otherAvgPremium),
                        ]);
                    });
                    break;
            }

            setData(policies);
            setDataPremium(totalPremium);
            setDataAvgPremium(averagePremium);
        }

        setLoading(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetData();
            setLoading(true);
        }
    }, [props.call]);

    return (
        <Grid container>
            <Grid item xs={12}>
                <TableWithContainer
                    title="BOUND POLICIES"
                    exportName="BoundPolicies"
                    loading={loading}
                    rowsPerPage={32}
                    fixedColumns={1}
                    style={style}
                    headers={headers}
                    rows={data.filter(x => x[0] !== "Total")}
                    footers={data.filter(x => x[0] === "Total")}
                />
            </Grid>
            <Grid item xs={12}>
                <TableWithContainer
                    title="TOTAL BOUND PREMIUM"
                    exportName="TotalBoundPremium"
                    loading={loading}
                    rowsPerPage={32}
                    fixedColumns={1}
                    style={style}
                    headers={headers}
                    rows={dataPremium.filter(x => x[0] !== "Total")}
                    footers={dataPremium.filter(x => x[0] === "Total")}
                />
            </Grid>
            <Grid item xs={12}>
                <TableWithContainer
                    title="AVERAGE BOUND PREMIUM"
                    exportName="AverageBoundPremium"
                    loading={loading}
                    rowsPerPage={32}
                    fixedColumns={1}
                    style={style}
                    headers={headers}
                    rows={dataAvgPremium.filter(x => x[0] !== "Total")}
                    footers={dataAvgPremium.filter(x => x[0] === "Total")}
                />
            </Grid>
        </Grid>
    );
}
